import { memo, useCallback } from "react";

import { Box, Center, Flex } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { Button, Text, Title } from "components";
import { AuthorityConstants } from "constant";
import { BankCreditService, CreditService } from "services";
import { CreditOptionsResponse, CreditResponse, UserResponse } from "types";
import { UserUtils } from "utils";

import CreditHeader from "./header";
import CreditTabs from "./tabs";

const { ROLE_CR_C } = AuthorityConstants;

interface ClientCreditProps {
  credit?: CreditResponse;
  options?: CreditOptionsResponse;
  user: UserResponse;
}

const ClientCreditComponent = ({ credit, options, user }: ClientCreditProps) => {
  const { t } = useTranslation();

  const createNewCredit = useCallback(() => {
    CreditService.creditsNew(user.id);
  }, [user]);

  const submitCreditRequest = useCallback(() => {
    if (credit?.id) {
      BankCreditService.bankCreditNew(credit.id);
    }
  }, [credit?.id]);

  if (!credit || !options) {
    return (
      <Box>
        {UserUtils.hasAuthority(ROLE_CR_C) && (
          <Button onClick={createNewCredit} mx={"sm"}>
            {t("credit.new.title")}
          </Button>
        )}
        <Center>
          <Box my={64} w={450}>
            <Title order={4} ta={"center"}>
              {t("credit.view.empty.title")}
            </Title>
            <Text ta={"center"}>{t("credit.view.empty.description")}</Text>
          </Box>
        </Center>
      </Box>
    );
  }

  return (
    <Box pb="xl">
      <CreditHeader credit={credit} />
      <CreditTabs credit={credit} options={options} readOnly={!!credit.bankCreditRequestId} />

      {UserUtils.hasAuthority(ROLE_CR_C) && !credit.bankCreditRequestId && (
        <Flex mt="md" justify="flex-end" pr="md">
          <Button onClick={submitCreditRequest} type="button">
            {t("credit.submit")}
          </Button>
        </Flex>
      )}
    </Box>
  );
};

const ClientCredit = memo(ClientCreditComponent);

export default ClientCredit;
